import React from 'react';
import { Link } from 'gatsby';

import './Navbar.scss';
export default function HideAppBar(props) {
  return (
    <div className="Navbar">
      <div className="MobileAppBar">
        <Link activeClassName="" className="siteTitle" to="/">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="165.5297mm"
            height="29.6391mm"
            viewBox="0 0 469.218 64.1738"
            className={'MobileLogo'}
          >
            <g
              id="a75c0133-f2d3-486a-a637-cdc46c23fc2e"
              data-name="TEXTE"
              fill="#6d8879"
            >
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M327.9674,18.7759h6.63c4.5239,0,7.4883,3.042,7.4883,7.7227s-2.9644,7.7217-7.4883,7.7217h-3.5884V46.9351h-3.042Zm3.042,12.87h3.1982c3.042,0,4.836-1.6377,4.836-5.1475s-1.794-5.1484-4.836-5.1484h-3.1982Z"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M345.673,18.7759h6.7861c4.5239,0,7.7222,2.6524,7.7222,7.293,0,3.1592-1.4038,5.8115-4.5239,6.9033l4.7583,13.9629h-3.1983L352.693,33.5963l-3.978.1562V46.9351h-3.042ZM348.715,31.1h2.6518c4.3682,0,5.7725-1.7159,5.7725-4.875s-1.4043-4.875-5.7725-4.875H348.715Z"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M372.3492,47.3248c-4.7583,0-7.9565-3.9776-7.9565-14.4688s3.1982-14.47,7.9565-14.47,7.9561,3.9775,7.9561,14.47S377.1071,47.3248,372.3492,47.3248Zm0-26.3643c-2.73,0-4.914,2.34-4.914,11.8955s2.1836,11.8955,4.914,11.8955,4.9141-2.3408,4.9141-11.8955S375.0792,20.9605,372.3492,20.9605Z"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M390.3668,18.7759V39.9146c0,5.7725-1.95,7.41-6.9419,7.41a9.4452,9.4452,0,0,1-1.56-.2334l.2339-2.6524a5.1785,5.1785,0,0,0,1.7548.3125c2.4576,0,3.4712-1.0537,3.4712-4.1347V18.7759Z"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M408.3854,18.7759V21.35h-9.8286v9.5947h7.2544v2.5742h-7.2544V44.3609h10.2964v2.5742H395.5148V18.7759Z"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M424.3746,27.2789c-.39-4.4463-1.7939-6.3184-4.1733-6.3184-3.5493,0-5.1089,3.12-5.1089,11.8955s1.56,11.8955,5.1089,11.8955c2.8472,0,4.4854-1.95,4.563-7.1767h3.0425c-.0782,6.24-2.8081,9.75-7.6055,9.75-5.0313,0-8.1514-3.8213-8.1514-14.4688s3.12-14.47,8.1514-14.47c4.1733,0,6.7476,2.8857,7.2153,8.8926Z"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M444.6154,18.7759V21.35h-5.772V46.9351h-3.042V21.35h-5.7725V18.7759Z"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M202.2589,21.4457c0-3.8887-1.728-6-7.1045-6H191.89v12.001h3.2641C200.5309,27.4467,202.2589,25.3344,202.2589,21.4457Z"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M158.6083,7.7582V54.0135H319.0719V7.7582Zm11.97,39.1777h-6.4322V12.2768h6.4322c7.2968,0,11.7133,4.0322,11.7133,17.33S177.8751,46.9359,170.5783,46.9359Zm31.7768,0L196.7868,30.519,191.89,30.71V46.9359h-3.7442V12.2768h8.3526c5.5683,0,9.5049,3.2646,9.5049,8.9765,0,3.8887-1.7281,7.1534-5.5684,8.4971l5.8564,17.1855Zm23.76,0-2.0645-10.2724h-8.8325l-2.0645,10.2724H209.41l7.6323-34.6591h5.1846L229.86,46.9359Zm25.8242,0h-3.1685l-5.4726-27.2187h-.0957L237.73,46.9359h-3.1684l-5.76-34.6591h3.4561l4.1284,27.0742h.0962l5.1845-27.0742h3.0723l5.3765,27.0742h.0957l3.84-27.0742h3.4565Zm13.1016,0H261.297V12.2768h3.7442Zm24.7685,0h-4.0322L275.0245,16.79h-.0961V46.9359h-3.7447V12.2768h5.857l8.9287,25.5381h.0957V12.2768H289.81ZM304.64,44.2475c3.5044,0,5.4243-1.92,5.4243-5.4727V33.8793h-4.7041V30.71h8.4487V46.9359h-2.4l-.48-2.5917a7.4149,7.4149,0,0,1-6.2885,3.0722c-6.0967,0-9.937-4.7051-9.937-17.81s3.84-17.8095,9.937-17.8095c6.3847,0,8.6889,5.5683,9.1689,11.1367h-3.7446c-.2881-4.5127-1.6318-7.9688-5.4243-7.9688-4.1763,0-6.1924,3.7442-6.1924,14.6416S300.464,44.2475,304.64,44.2475Z"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M169.9064,15.4457H167.89V43.768h2.0161c5.4726,0,8.6406-2.3047,8.6406-14.1612S175.379,15.4457,169.9064,15.4457Z"
              />
              <polygon
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                points="219.587 14.87 215.746 33.495 223.523 33.495 219.683 14.87 219.587 14.87"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M33.0463,18.7784v2.5742h-5.772V46.9375h-3.042V21.3526H18.46V18.7784Z"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M38.9735,18.7784V30.9473h8.2681V18.7784h3.0425V46.9375H47.2416V33.5215H38.9735v13.416h-3.042V18.7784Z"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M68.3021,18.7784v2.5742H58.4735v9.5947h7.2544v2.5742H58.4735V44.3633H68.77v2.5742H55.4315V18.7784Z"
              />
              <path
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                d="M77.9,7.7582V54.0135h77.6106V7.7582ZM98.9735,46.9375H83.9965V12.2784h3.7441V43.77H98.9735Zm7.7266,0h-3.7446V12.2784H106.7Zm15.84,0h-3.4565l-8.1607-34.6591h3.7442l6.0967,27.459h.0962l6.0961-27.459h3.7447Zm28.5113,0h-16.417V12.2784h15.8413v3.1689H138.3783V27.2559h8.9287v3.168h-8.9287V43.77h12.6729Z"
              />
              <rect
                class="b742070a-1d74-440a-8a78-f28351ec7a1e"
                x="152.9143"
                y="7.7582"
                width="8.0869"
                height="46.2552"
              />
            </g>
          </svg>
        </Link>
      </div>
    </div>
  );
}
